import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  position: relative;
  min-height: 210px;
`;

export const Header = styled.header`
  border-bottom: 1px solid #ddd;
  color: #000;
  font-weight: 600;
  text-transform: capitalize;
  padding: 15px 10px 5px 10px;
  margin: 0 20px;
  display: flex;
  justify-content: space-between;
  overflow: hidden;

  .panel-title {
    font-size: 1em;
    display: flex;
    justify-content: space-between;
    position: relative;
  }

  ${mediaMaxWidth.tablet`
    background: #fff !important;
    padding: 5px 0;

    .panel-title {
      padding: 20px 15px 5px 15px;
      color: #525252;
      background: #ffffff;
      text-align: left;
      border-top: 2px solid #fff;
      letter-spacing: 1px;
      width: calc(100vw - 40px) !important;
      margin-top: -10px;
      margin-left: -15px;
      font-size: 0.875em;
    }
  `}
`;

export const Body = styled.div`
  padding: 15px;
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  margin: 10px 0;

  ${mediaMaxWidth.phone`
    flex-wrap: wrap;
  `}
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: ${(props) => props.flex};
  align-items: center;

  svg {
    position: relative;
    color: #bbbbbb;
    top: 14px;
  }

  .__react_component_tooltip.show {
    text-align: center;
  }

  ${mediaMaxWidth.phone`
    display: ${(props) => props.noMobile && "none"};
    padding: 0 15px;
  `}
`;

export const Number = styled.div`
  display: flex;
  font-size: ${(props) => props.fontSize === "large" && "2.4em"};
  font-size: ${(props) => props.fontSize === "medium" && "1.7em"};
  position: relative;
  padding-right: 10px;

  ${mediaMaxWidth.phone`
    font-size: ${(props) => props.fontSize === "large" && "1.8em"};
    font-size: ${(props) => props.fontSize === "medium" && "1.4em"};
  `}
`;

export const Description = styled.div`
  display: flex;
  font-size: 0.9em;
  letter-spacing: 0.02em;
  margin: 15px 0;
  text-align: center;

  ${mediaMaxWidth.phone`
    font-size: 0.8em;
    margin: 10px 0;
  `}
`;
